import {AppTitlePathInterface} from '../shared/interfaces';

export type ObjectAppTitleKey = keyof typeof AppTitlePathUtils;

export const AppTitlePathUtils: AppTitlePathInterface = {
  'selectforcheckin': 'Select for Check-in',
  'guestsummary': 'Guest Summary',
  'guestdetails': 'Guest Details',
  'onboardexpenses': 'Onboard Expenses',
  'cruisedetails': 'Cruise Contracts',
  'arrivalinfo': 'Arrival Time',
  'confirmation': 'Confirmation',
  'boardingpass': 'Boarding Pass',
  'error': 'Error Page',
  'frequently-asked-questions': 'Frequently Asked Questions',
  'health': 'Health',
}
